import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  margin-bottom: 1rem;
  position: absolute;
  top: 50%;
  right: -2rem;
  transform: translateY(-45%);
`;

export const ComponentWrapper = styled.div`
  margin: 0 0.5rem;
`;
